import { render, staticRenderFns } from "./MyLoans.vue?vue&type=template&id=611308fc&scoped=true"
import script from "./MyLoans.vue?vue&type=script&lang=js"
export * from "./MyLoans.vue?vue&type=script&lang=js"
import style0 from "./MyLoans.vue?vue&type=style&index=0&id=611308fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611308fc",
  null
  
)

export default component.exports